import React, { PureComponent, PropTypes } from 'react';

import './CheckBox.css';

export default class CheckBox extends PureComponent {
    static propTypes = {
        label: PropTypes.string.isRequired,
        isChecked: PropTypes.bool.isRequired,
        onChange: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        const { isChecked } = this.props;

        this.props.onChange(!isChecked);
    }

    render() {
        const { label, isChecked, onClick } = this.props;

        const checkedCssClass = isChecked ? `checked` : ``;

        return (
            <div className={`checkbox ${checkedCssClass}`} onClick={this.onClick}>
                <span className="label">{label}</span>
                <span className="icon material-icons" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/CheckBox.jsx